export type CardBrand = "visa" | "mastercard" | "unionpay";
export type CardStatus = "active" | "processing" | "frozen";
export type CardKind = "virtual" | "physical";

export interface CardLimits {
  monthly: number;
  used: number;
  currency: string;
}

export interface UserCard {
  id: string;
  provider: string;
  brand: CardBrand;
  kind: CardKind;
  status: CardStatus;
  name: string;
  cardholderName: string;
  /** Полный номер сейчас не отдаётся API (шифрованный, PCI). */
  fullNumber: string;
  lastFour: string;
  expiry: string;
  cvv: string;
  balance: number;
  currency: string;
  limits?: CardLimits;
  issuedAt?: string;
  /**
   * Дизайн-шаблон карты. Пришёл из `CardOffer.image_url` / `image_url_dark`
   * (загружается в админке). URL или data URL. Если пусто — рисуем `gradient`
   * как раньше.
   */
  imageUrl?: string;
  imageUrlDark?: string;
  gradient: string;
}

export interface CardOffer {
  id: string;
  /** Отображаемое имя провайдера, например `Airwallex`. */
  provider: string;
  /** Стабильный код провайдера (`airwallex`, `highnote`, `ibt`, …). */
  providerCode: string;
  /** Страна провайдера, если есть — рендерим в offer-карточке. */
  providerCountry?: string;
  name: string;
  description: string;
  price: string;
  priceComment?: string;
  issueTime: string;
  features: string[];
  /** См. UserCard.imageUrl* — тот же паттерн, из `CardOffer.image_url*`. */
  imageUrl?: string;
  imageUrlDark?: string;
  gradient: string;
  badge?: string;
}

/** Форматирует номер карты пачками по 4: 4111 2222 3333 4521 */
export function formatCardNumber(raw: string): string {
  return raw.replace(/(\d{4})(?=\d)/g, "$1 ");
}

/** Маскирует номер: •••• •••• •••• 4521 */
export function maskCardNumber(raw: string): string {
  if (!raw) return "•••• •••• •••• ••••";
  const last4 = raw.slice(-4);
  return `•••• •••• •••• ${last4}`;
}
